module.exports = __webpack_public_path__ + "static/media/nutrition-secondary.377fa507.jpg";